"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_ROLE = 'ADMIN';
exports.CARER_ROLE = 'CARER';
exports.CUSTOMER_CARER_ROLE = 'CUSTOMER_CARER';
exports.CUSTOMER_COORDINATOR_ROLE = 'CUSTOMER_COORDINATOR';
exports.CARER_COORDINATOR_ROLE = 'CARER_COORDINATOR';
exports.COORDINATOR_ROLE = 'COORDINATOR';
exports.FAMILY_ROLE = 'FAMILY';
exports.CUSTOMER_FAMILY_ROLE = 'CUSTOMER_FAMILY';
exports.ORGANISATION_ADMIN_ROLE = 'ORG_ADMIN';
exports.GLOBAL_ROLES = [exports.ADMIN_ROLE];
exports.ORGANISATION_ROLE_HEIRARCHY = [
    exports.ADMIN_ROLE,
    exports.ORGANISATION_ADMIN_ROLE,
    exports.COORDINATOR_ROLE,
    exports.CARER_ROLE,
    exports.FAMILY_ROLE
];
exports.DASHBOARD_ROLES = [exports.ADMIN_ROLE, exports.ORGANISATION_ADMIN_ROLE, exports.COORDINATOR_ROLE];
exports.STAFF_ROLES = [exports.ORGANISATION_ADMIN_ROLE, exports.COORDINATOR_ROLE, exports.CARER_ROLE];
exports.ORGANISATION_ROLES = [
    exports.ORGANISATION_ADMIN_ROLE,
    exports.COORDINATOR_ROLE,
    exports.CARER_ROLE,
    exports.FAMILY_ROLE
];
exports.CARER_ROLES = [exports.CARER_COORDINATOR_ROLE];
exports.CUSTOMER_ROLES = [
    exports.CUSTOMER_COORDINATOR_ROLE,
    exports.CUSTOMER_CARER_ROLE,
    exports.CUSTOMER_FAMILY_ROLE
];
exports.ROLES = Array.from(new Set(exports.GLOBAL_ROLES.concat(exports.ORGANISATION_ROLES, exports.CARER_ROLES, exports.CUSTOMER_ROLES)));
exports.CUSTOMER_ROLE_HERIRARCHY = [
    exports.ADMIN_ROLE,
    exports.ORGANISATION_ADMIN_ROLE,
    exports.CUSTOMER_COORDINATOR_ROLE,
    exports.COORDINATOR_ROLE,
    exports.CUSTOMER_CARER_ROLE,
    exports.CARER_ROLE,
    exports.CUSTOMER_FAMILY_ROLE,
    exports.FAMILY_ROLE
];
//# sourceMappingURL=roles.js.map